import { render, staticRenderFns } from "./editLanguage.vue?vue&type=template&id=32bb9758&"
import script from "./editLanguage.vue?vue&type=script&lang=js&"
export * from "./editLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports